import { Component, ViewChild, ElementRef, Injector } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Overlay, OverlayRef, OverlayConfig } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { UserActionMenuDropdownComponent } from './user-action-menu-dropdown.component';

@Component({
  selector: 'app-user-action-cell-renderer',
  template: `
    <div class="action-btn-wrapper">
      <button
        #actionButton
        class="btn btn-outline-primary action-btn"
        (click)="toggleDropdown($event)"
        type="button">
        <i class="fas fa-ellipsis-v"></i>
      </button>
    </div>
  `,
  styles: [`
    .action-btn-wrapper {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .action-btn {
      width: 28px;
      height: 28px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `]
})
export class UserActionCellRendererComponent implements ICellRendererAngularComp {

  @ViewChild('actionButton', { static: true }) actionButton!: ElementRef;

  params!: ICellRendererParams;
  overlayRef: OverlayRef | null = null;
  isDropdownOpen = false;

  constructor(
    private overlay: Overlay,
    private injector: Injector
  ) {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }

  toggleDropdown(event: Event): void {
    event.stopPropagation();

    if (this.isDropdownOpen) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  private openDropdown(): void {
    const ctx = this.params?.context;
    if (!ctx) return;

    this.isDropdownOpen = true;

    const config = new OverlayConfig({
      positionStrategy: this.overlay.position()
        .flexibleConnectedTo(this.actionButton)
        .withPositions([
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top'
          },
          {
            originX: 'end',
            originY: 'top',
            overlayX: 'end',
            overlayY: 'bottom'
          }
        ]),
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop'
    });

    this.overlayRef = this.overlay.create(config);

    const data = {
      rowData: this.params.data
    };

    const portal = new ComponentPortal(
      UserActionMenuDropdownComponent,
      null,
      Injector.create({
        providers: [
          { provide: 'ACTION_MENU_DATA', useValue: data }
        ],
        parent: this.injector
      })
    );

    const componentRef = this.overlayRef.attach(portal);

    componentRef.instance.actionClicked.subscribe((res: any) => {
      this.handleAction(res);
      this.closeDropdown();
    });

    this.overlayRef.backdropClick().subscribe(() => {
      this.closeDropdown();
    });
  }

  private closeDropdown(): void {
    this.overlayRef?.dispose();
    this.overlayRef = null;
    this.isDropdownOpen = false;
  }

  private handleAction(res: any): void {
    const ctx = this.params.context;
    const user = res.rowData;

    switch (res.action) {
      case 'editUser':
        ctx.editUser(user);
        break;

      case 'deleteUser':
        ctx.deleteUser(user);
        break;
    }
  }
}